import { useTranslation } from "react-i18next";
import { FixedWidthTileCarousel } from "~/common/components/carousel/FixedWidthTileCarousel";
import { Card, CardActionArea, CardMedia, Stack, Typography } from "~/common/mui";

interface TileData {
  title: string;
  imageUrl: string;
  url?: string;
  onClick?: () => void;
}

export const ChildCategoryNavigationCarousel = ({ items }: { items: TileData[] }) => {
  const { t } = useTranslation();

  return (
    <FixedWidthTileCarousel gap={24} itemWidth={168} items={items}>
      {(item: TileData) => (
        <Card
          sx={{ width: "168px", height: "100%" }}
          tracking-aux-sub-category-name={t(item.title, { lng: "en" })}
          tracking-aux-sub-category-url={item.url}
        >
          <CardActionArea href={item.url as string} onClick={item.onClick} sx={{ p: 2, height: "100%" }}>
            <Stack gap={2}>
              <CardMedia image={item.imageUrl} sx={{ height: 80 }} />
              <Typography variant="titleSmall">{t(item.title)}</Typography>
            </Stack>
          </CardActionArea>
        </Card>
      )}
    </FixedWidthTileCarousel>
  );
};

function getComponentTag(item: TileData) {
  if (item.onClick) {
    return "button";
  }
  if (item.url) {
    return "a";
  }
  return undefined;
}
